import { Component, OnInit } from '@angular/core';
import { isODM } from '../../../environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { trigger, style, transition, animate } from '@angular/animations';


@Component({
  standalone: false,
  selector: 'app-help-msp',
  templateUrl: './help-msp.component.html',
  styleUrls: ['./help-msp.component.css'],
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('.3s', style({ opacity: 1 }))
      ]),
    ])
  ]
})
export class HelpMspComponent implements OnInit {

  constructor(private ngxService: NgxUiLoaderService) {
  }

  ngOnInit() {
    this.ngxService.start();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-help');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.ngxService.stop();
  }

}
